export enum FulfilmentPicRoutingMode {
  N8N = 'N8N',
  DISABLED = 'DISABLED',
}

export enum FulfilmentPicWeekday {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

/** Kind of internal purchase a PIC is preferred for; mirrors the Facade `FulfilmentPicPurpose` contract. */
export enum FulfilmentPicPurpose {
  COUPANG_PURCHASE = 'COUPANG_PURCHASE',
  NON_COUPANG_PURCHASE = 'NON_COUPANG_PURCHASE',
  BULK_PURCHASE = 'BULK_PURCHASE',
  GIG_HANDBACK = 'GIG_HANDBACK',
}

export interface FulfilmentPicProfile {
  picId: string;
  name: string;
  slackId: string;
  activeDays: FulfilmentPicWeekday[];
  isActive: boolean;
  leaveStart: string | null;
  leaveEnd: string | null;
  weight: number;
  weekendAssignments: string[];
  /** Every purpose the PIC holds; wins over `purpose` when non-empty. Older Facade versions omit it. */
  purposes?: FulfilmentPicPurpose[];
  /** Legacy single purpose, written as `purposes[0]` for older readers. Absent or null means no purpose. */
  purpose?: FulfilmentPicPurpose | null;
}

/** Reads a PIC's purposes from `purposes`, falling back to the legacy single `purpose`. */
export const resolvePicPurposes = (pic: FulfilmentPicProfile): FulfilmentPicPurpose[] => {
  if (pic.purposes && pic.purposes.length > 0) {
    return pic.purposes;
  }
  return pic.purpose ? [pic.purpose] : [];
};

export interface FulfilmentPicConfig {
  routingMode: FulfilmentPicRoutingMode;
  gigworkAllocationPercentage: number;
  gigworkRewardKrw: number;
  gigworkExcludedBrandSlugs: string[];
  pics: FulfilmentPicProfile[];
}

export interface VersionedFulfilmentPicConfig {
  version: number;
  config: FulfilmentPicConfig;
}
